// @flow

import React from 'react'

import { connect } from 'react-redux'
import { customerSort } from '../helpers'
import Checkbox from './Checkbox/Checkbox'
import { selectFilteredCustomers } from '../stores/customersStore'

type Customer = {
  id: string,
  name: string,
  label: string,
  brand: boolean,
  country: string,
  language: string,
}

type Props = {
  onChange: Function,
  customers: Array<Customer>,
  customerIds: [string],
  setCustomer: Function,
  removeCustomer: Function,
  disabled: boolean,
}

export function CustomerCheckbox({
  onChange,
  customers,
  customerIds,
  setCustomer,
  removeCustomer,
  disabled = false,
}: Props) {
  const sortedCustomers = customers.slice().sort(customerSort)

  const onChangeHandler = customer => {
    if (customerIds.indexOf(customer) === -1) {
      setCustomer(customer)
    } else {
      removeCustomer(customer)
    }
  }

  const Customer = ({ customer }) => {
    return (
      <div className="dib w-50 w-30-m w-20-l pr4 mb4">
        <Checkbox
          onChange={onChangeHandler}
          label={customer.label}
          isChecked={customerIds.indexOf(customer.label) !== -1}
        />
      </div>
    )
  }

  return (
    <div className="w-100">
      {sortedCustomers.map((customer, i) => (
        <Customer key={i} customer={customer} />
      ))}
    </div>
  )
}

function toOption(customer: Customer) {
  return {
    value: customer.id,
    label: customer.name,
    brand: customer.brand,
    country: customer.country,
    language: customer.language,
  }
}

const mapStateToProps = state => ({
  customers: selectFilteredCustomers(state).map(toOption),
})

export default connect(mapStateToProps)(CustomerCheckbox)



// WEBPACK FOOTER //
// ./src/components/CustomerCheckbox.js